/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.1",
    versionName: "0.2.0-nightly.2025.8.1",
    versionChannel: "nightly",
    buildDate: "2025-08-01T00:08:46.758Z",
    commitHash: "da99eb08eb23e14dbf4c1b4603da7d3e1b4f01f3",
};
